import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const getLanguageFromPath = (path: string): string => {
  if (path.startsWith("/en")) return "en";
  if (path.startsWith("/de")) return "de";
  if (path.startsWith("/pt")) return "pt";
  if (path.startsWith("/fr")) return "fr";
  if (path.startsWith("/admin")) return "admin";
  return "es";
};

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const lang = getLanguageFromPath(location.pathname);
    if (lang === "admin") return;

    import("@/integrations/supabase/client").then(({ supabase }) => {
      supabase.functions
        .invoke("track-page-view", {
          body: {
            page_path: location.pathname,
            language: lang,
            user_agent: navigator.userAgent,
            referrer: document.referrer || null,
          },
        })
        .catch(() => {});
    });
  }, [location.pathname]);

  return null;
};

export default PageViewTracker;
